export default "__VITE_ASSET__b170d3b6__"